/**
 * KpiCard — card de KPI único das páginas de Marketing.
 *
 * Aceita `kpi` ({icon,label,value,hint}, com label/value/hint opcionalmente
 * {simple,advanced} resolvidos por `mode`) ou as props soltas. Vira botão
 * quando recebe `onClick`.
 */
import Icon from './icons.jsx'

function resolveField(field, mode) {
  if (field && typeof field === 'object' && (field.simple || field.advanced)) {
    return field[mode] ?? field.simple
  }
  return field
}

export default function KpiCard({ kpi, mode = 'simple', onClick, icon, label, value, hint }) {
  const src = kpi || { icon, label, value, hint }
  const l = resolveField(src.label, mode)
  const v = resolveField(src.value, mode)
  const h = resolveField(src.hint, mode)
  const Tag = onClick ? 'button' : 'div'
  const extra = onClick ? { type: 'button', onClick, 'aria-label': `${l}: ${v}` } : {}
  return (
    <Tag className="kpi-card" title={h} {...extra}>
      <div className="kpi-head">
        <span className="kpi-icon"><Icon n={src.icon} s={14} /></span>
        <span className="kpi-label">{l}</span>
      </div>
      <div className="kpi-value">{v}</div>
      <div className="kpi-foot"><span className="kpi-hint">{h}</span></div>
    </Tag>
  )
}
